module.exports = __webpack_public_path__ + "img/file---------------------------------------@1x.2b2deb0f.png";